import ReportPage from "../../components/ReportPage";
import { downloadDistributionDetail } from "../../API";

const schema = {
  title: "Stores Not Selling Report",
  params: [
    { name: "banners", label: "Banner", type: "multiselect", route: "banners", payloadKey: "bannerIds", required: true },
    {
      name: "products",
      label: "Products",
      type: "multiselect",
      route: "products",
      cascadesFrom: "manufacturer",
      fields: ["description", "formatQut", "format"],
      payloadKey: "productIds",
      required: false,
      dependsOnValues: ["banners"],
      buildQueryFn: (manufacturer, commonParams, localValues) => {
        const p = new URLSearchParams();
        p.set("manufacturerId", manufacturer.id);
        const status = localValues?.productStatus?.id ?? commonParams.itemStatus ?? "ACTIVE";
        if (status !== "ALL") p.set("status", status);
        (commonParams.provinces ?? []).forEach((pr) => p.append("provinceIds", pr.id));
        ((localValues ?? {}).banners ?? []).forEach((b) => p.append("bannerIds", b.id));
        return `/for-report-selector?${p.toString()}`;
      },
    },
  ],
  downloadFn: downloadDistributionDetail,
};

export default function DistributionDetailReport() {
  return <ReportPage schema={schema} />;
}
